module.exports = __webpack_public_path__ + "static/media/Lumena Energy Icon and Text white dark background logo tm.b05cf0eb.png";